import React, { useEffect } from "react";
import {
  ChevronRight,
  Package,
  Truck,
  X,
} from "lucide-react";
import i18next from "i18next";

const COPY = {
  ru: {
    title: "Мои объявления",
    freight: "Грузы",
    freightDesc: "Добавить, активные и история",
    vehicles: "Мои машины",
    vehiclesDesc: "Добавить, активные и история",
    close: "Закрыть",
  },
  uz: {
    title: "Менинг эълонларим",
    freight: "Юклар",
    freightDesc: "Қўшиш, фаол ва тарих",
    vehicles: "Менинг машиналарим",
    vehiclesDesc: "Қўшиш, фаол ва тарих",
    close: "Ёпиш",
  },
  tr: {
    title: "İlanlarım",
    freight: "Yükler",
    freightDesc: "Ekle, aktif ve geçmiş",
    vehicles: "Araçlarım",
    vehiclesDesc: "Ekle, aktif ve geçmiş",
    close: "Kapat",
  },
};

function langCode() {
  const raw = String(i18next.language || "").toLowerCase();
  if (raw.startsWith("uz")) return "uz";
  if (raw.startsWith("tr")) return "tr";
  return "ru";
}

export default function DriverMyAdsSheet({
  open,
  onClose,
  onFreight,
  onVehicles,
}) {
  const lang = langCode();
  const t = COPY[lang] || COPY.ru;

  useEffect(() => {
    if (!open) return undefined;

    const onKeyDown = (event) => {
      if (event.key === "Escape") {
        onClose?.();
      }
    };

    window.addEventListener("keydown", onKeyDown);

    return () => {
      window.removeEventListener("keydown", onKeyDown);
    };
  }, [open, onClose]);

  if (!open) return null;

  const choose = (handler) => {
    onClose?.();
    handler?.();
  };

  return (
    <div
      className="fixed inset-0 z-[10080] flex items-end justify-center"
      role="dialog"
      aria-modal="true"
      aria-label={t.title}
    >
      <button
        type="button"
        className="absolute inset-0 bg-black/55"
        onClick={onClose}
        aria-label={t.close}
      />

      <div className="relative w-full max-w-[760px] rounded-t-[28px] border border-slate-700 bg-slate-900 px-4 pb-[max(24px,env(safe-area-inset-bottom))] pt-3 shadow-2xl"
        data-reisor-theme-surface="driver-my-ads">
        <div className="mx-auto mb-2 h-1.5 w-14 rounded-full bg-slate-600" />

        <div className="flex items-center justify-between px-1 py-3">
          <h2 className="text-2xl font-black text-white">
            {t.title}
          </h2>

          <button
            type="button"
            onClick={onClose}
            className="flex h-10 w-10 items-center justify-center rounded-xl text-slate-400"
            aria-label={t.close}
          >
            <X size={22} />
          </button>
        </div>

        <div className="space-y-2">
          <button
            type="button"
            onClick={() => choose(onFreight)}
            className="flex w-full items-center gap-4 rounded-2xl border border-slate-700 bg-slate-950/70 p-4 text-left"
          >
            <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-blue-600 text-white">
              <Package size={25} />
            </span>

            <span className="min-w-0 flex-1">
              <span className="block text-lg font-black text-white">
                {t.freight}
              </span>

              <span className="mt-0.5 block text-sm text-slate-400">
                {t.freightDesc}
              </span>
            </span>

            <ChevronRight size={23} className="text-slate-500" />
          </button>

          <button
            type="button"
            onClick={() => choose(onVehicles)}
            className="flex w-full items-center gap-4 rounded-2xl border border-slate-700 bg-slate-950/70 p-4 text-left"
          >
            <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-blue-600 text-white">
              <Truck size={26} />
            </span>

            <span className="min-w-0 flex-1">
              <span className="block text-lg font-black text-white">
                {t.vehicles}
              </span>

              <span className="mt-0.5 block text-sm text-slate-400">
                {t.vehiclesDesc}
              </span>
            </span>

            <ChevronRight size={23} className="text-slate-500" />
          </button>
        </div>
      </div>
    </div>
  );
}
